var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSubscribeChat(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 57,
    viewBox: "0 0 57 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9826_93)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 57,
    height: 57,
    rx: 28.5,
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.7693 17.0265C30.8091 16.8013 33.785 18.0194 35.9313 20.3732C38.0777 22.727 39.1854 25.9865 38.9746 29.3178C38.5896 35.4074 33.6791 40 27.5523 40H22.375C19.9626 40 18 37.8503 18 35.2081V28.8252C18.0009 22.6168 22.2919 17.4338 27.7693 17.0265ZM32.8758 29.9369C33.6003 29.9369 34.1883 29.2929 34.1883 28.4994C34.1883 27.7058 33.6003 27.0618 32.8758 27.0618C32.1513 27.0618 31.5633 27.7058 31.5633 28.4994C31.5633 29.2929 32.1513 29.9369 32.8758 29.9369ZM28.5008 29.9369C29.2253 29.9369 29.8133 29.2929 29.8133 28.4994C29.8133 27.7058 29.2253 27.0618 28.5008 27.0618C27.7763 27.0618 27.1883 27.7058 27.1883 28.4994C27.1883 29.2929 27.7763 29.9369 28.5008 29.9369ZM24.1259 29.9369C24.8504 29.9369 25.4384 29.2929 25.4384 28.4994C25.4384 27.7058 24.8504 27.0618 24.1259 27.0618C23.4014 27.0618 22.8134 27.7058 22.8134 28.4994C22.8134 29.2929 23.4014 29.9369 24.1259 29.9369Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9826_93"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 57,
    height: 57,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubscribeChat);
export default __webpack_public_path__ + "static/media/subscribe-chat.4c597cc2d2e01d2ff892f06a5df507b1.svg";
export { ForwardRef as ReactComponent };